import {
  headline,
  text,
  field,
  button,
  spacer,
  rank,
  survey
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/Base/_base'
import {
  position,
  type,
  trigger,
  animation,
  maxWidth,
} from '@meta/widget/options.js'
import { typeTag, tag } from '@meta/widget/templates.js'
const info = {
  name: 'Website Feedback',
  templateID: '9',
  description:
    'Gather comprehensive feedback on your website\'s usability and content with the "Website Feedback" widget. This tool is designed to collect detailed user opinions, helping you enhance the overall user experience.',
  tags: [typeTag.FLYOUT, tag.FEEDBACK],
}

const json = {
  id: 89625275,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme: themes.MONOCHROME.theme,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.trigger = trigger.AUTO
    customSettings.position = position.CENTER
    customSettings.animation = animation.SLIDE
    return customSettings
  })(),
   styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.MEDIUM
    return customStyling
  })(),
  steps: [
    {
      id: 'd284x6u',
      contentItems: [
        (() => {
          const headlineCopy = JSON.parse(JSON.stringify(headline))
          headlineCopy.content.text = 'We Value Your Feedback! We\'d like to know what you think about our website.'
          Object.assign(headlineCopy.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return headlineCopy
        })(),
        (() => {
          const textCopy = JSON.parse(JSON.stringify(text))
          textCopy.content.text = '<p>3 questions, less than 20 seconds.</p>'
          Object.assign(textCopy.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return textCopy
        })(),
        (() => {
          const buttonCopy = JSON.parse(JSON.stringify(button))
          buttonCopy.content.text = 'Start'
          Object.assign(buttonCopy.styling, {
            color: 'rgb(255, 255, 255)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '2px',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          buttonCopy.settings.backBtn = false
          return buttonCopy
        })(),
      ],
    },
    {
      id: 'sl0cikq',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Did you find what you were looking for today?'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customSurvey = JSON.parse(JSON.stringify(survey))
          customSurvey.content.options = [
            { id: 'm48yqtv', text: 'Yes' },
            { id: 'eemag7v', text: 'No' },
          ]
          Object.assign(customSurvey.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '16px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(128, 128, 128, 1)',
            borderWidth: '2px',
            borderRadius: '0px',
            backgroundColor: 'rgb(232, 232, 232)',
          })
          customSurvey.settings.label = 'Task Complete'
          customSurvey.settings.required = true
          return customSurvey
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Next'
          Object.assign(customButton.styling, {
            color: 'rgb(255, 255, 255)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '2px',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.href = ''
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '14xbiwl',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'On a scale 1-5, how easy was it to find the information you were looking for on our website?'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customRank = JSON.parse(JSON.stringify(rank))
          Object.assign(customRank.styling, {
            align: 'center',
            endColor: '#FF9900',
            baseColor: 'rgba(128, 128, 128, 1)',
            startColor: '#99A9BF',
            middleColor: '#F7BA2A',
          })
          customRank.settings.type = 'smile'
          customRank.settings.count = 5
          customRank.settings.label = 'Information Ease'
          customRank.settings.required = true
          return customRank
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Next'
          Object.assign(customButton.styling, {
            color: 'rgb(255, 255, 255)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '2px',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.href = ''
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: 'sapek1g',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Did you encounter any issues or difficulties while using our website?'
          Object.assign(customHeadline.styling, {
            color: 'rgba(24, 23, 26, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Enter text here'
          Object.assign(customField.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(128, 128, 128, 1)',
            borderWidth: '2px',
            borderRadius: '0px',
            backgroundColor: 'rgb(255, 255, 255)',
          })
          customField.settings.type = 'text'
          customField.settings.label = 'Issues encountered'
          customField.settings.required = false
          return customField
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Next'
          Object.assign(customButton.styling, {
            color: 'rgb(255, 255, 255)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '2px',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.href = ''
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '23ttlf6',
      contentItems: [
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Thank you for taking the time to share your thoughts!'
          Object.assign(customHeadline.styling, {
            color: 'rgb(24, 23, 26)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>These results will help us create a better website experience for you.</p>'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '16px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '19px'
          return customSpacer
        })(),
      ],
    },
  ],
}

export { json, info }